import { pluralize } from '@joyful/utils'

import { useUntriagedDropboxItemsCount } from '../../dropbox/hooks/useUntriagedDropboxItemsCount'
import { NavigationItemBadge } from './NavigationItemBadge'

export function DropboxNavBadge() {
  const { formattedUntriagedCount, untriagedCount } =
    useUntriagedDropboxItemsCount()

  if (untriagedCount <= 0) {
    return null
  }

  return (
    <NavigationItemBadge
      aria-label={pluralize(untriagedCount, 'untriaged Dropbox file')}
    >
      {formattedUntriagedCount}
    </NavigationItemBadge>
  )
}
